
const LoadingPlaceholder: React.FC = () => {
    return (
        <div className="d-flex justify-content-center my-5 p-5 bl-light">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default LoadingPlaceholder